/**
 * Initialisation Sentry pour la sandbox Vue.
 *
 * No-op total si SENTRY_DSN est vide (dev local sans config).
 * DSN injecté via runtime-config (window.__RUNTIME_CONFIG__) — voir shared/config.ts.
 */

import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
  SENTRY_TRACES_SAMPLE_RATE,
} from '@/shared/config';

const SENSITIVE_HEADER_RE = /authorization|cookie|x-api-key/i;

export function initSentry(app: App, router: Router): void {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE || undefined,
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    beforeSend(event) {
      const headers = event.request?.headers;
      if (headers && typeof headers === 'object') {
        for (const key of Object.keys(headers)) {
          if (SENSITIVE_HEADER_RE.test(key)) {
            (headers as Record<string, string>)[key] = '[Filtered]';
          }
        }
      }
      return event;
    },
  });
}
